// source: proto/management.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.auctionboost.Address', null, global);
goog.exportSymbol('proto.auctionboost.Auction', null, global);
goog.exportSymbol('proto.auctionboost.AuctionSeries', null, global);
goog.exportSymbol('proto.auctionboost.CheckedInResponse', null, global);
goog.exportSymbol('proto.auctionboost.CheckoutPersonRequest', null, global);
goog.exportSymbol('proto.auctionboost.CheckoutPersonResponse', null, global);
goog.exportSymbol('proto.auctionboost.ClerkItemResponse', null, global);
goog.exportSymbol('proto.auctionboost.ClerkedItem', null, global);
goog.exportSymbol('proto.auctionboost.DeletionRequest', null, global);
goog.exportSymbol('proto.auctionboost.DeletionResponse', null, global);
goog.exportSymbol('proto.auctionboost.Email', null, global);
goog.exportSymbol('proto.auctionboost.EntityReference', null, global);
goog.exportSymbol('proto.auctionboost.Guest', null, global);
goog.exportSymbol('proto.auctionboost.Invoice', null, global);
goog.exportSymbol('proto.auctionboost.Invoice.BuyersAddressChoiceCase', null, global);
goog.exportSymbol('proto.auctionboost.Invoice.BuyersEmailChoiceCase', null, global);
goog.exportSymbol('proto.auctionboost.Item', null, global);
goog.exportSymbol('proto.auctionboost.ItemType', null, global);
goog.exportSymbol('proto.auctionboost.MessageType', null, global);
goog.exportSymbol('proto.auctionboost.Money', null, global);
goog.exportSymbol('proto.auctionboost.Organization', null, global);
goog.exportSymbol('proto.auctionboost.Person', null, global);
goog.exportSymbol('proto.auctionboost.PersonLabel', null, global);
goog.exportSymbol('proto.auctionboost.Response', null, global);
goog.exportSymbol('proto.auctionboost.SearchTerm', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.DeletionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.DeletionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.DeletionRequest.displayName = 'proto.auctionboost.DeletionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.EntityReference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.EntityReference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.EntityReference.displayName = 'proto.auctionboost.EntityReference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Response.displayName = 'proto.auctionboost.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.DeletionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.DeletionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.DeletionResponse.displayName = 'proto.auctionboost.DeletionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Email = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.Email, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Email.displayName = 'proto.auctionboost.Email';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Address.displayName = 'proto.auctionboost.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Person = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.auctionboost.Person.repeatedFields_, null);
};
goog.inherits(proto.auctionboost.Person, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Person.displayName = 'proto.auctionboost.Person';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Organization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.auctionboost.Organization.repeatedFields_, null);
};
goog.inherits(proto.auctionboost.Organization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Organization.displayName = 'proto.auctionboost.Organization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.PersonLabel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.PersonLabel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.PersonLabel.displayName = 'proto.auctionboost.PersonLabel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.AuctionSeries = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.AuctionSeries, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.AuctionSeries.displayName = 'proto.auctionboost.AuctionSeries';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Auction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.auctionboost.Auction.repeatedFields_, null);
};
goog.inherits(proto.auctionboost.Auction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Auction.displayName = 'proto.auctionboost.Auction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Money = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.Money, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Money.displayName = 'proto.auctionboost.Money';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Item.displayName = 'proto.auctionboost.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.SearchTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.SearchTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.SearchTerm.displayName = 'proto.auctionboost.SearchTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Guest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.Guest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Guest.displayName = 'proto.auctionboost.Guest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.CheckedInResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.CheckedInResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.CheckedInResponse.displayName = 'proto.auctionboost.CheckedInResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.ClerkedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.ClerkedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.ClerkedItem.displayName = 'proto.auctionboost.ClerkedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.ClerkItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.ClerkItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.ClerkItemResponse.displayName = 'proto.auctionboost.ClerkItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.CheckoutPersonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.CheckoutPersonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.CheckoutPersonRequest.displayName = 'proto.auctionboost.CheckoutPersonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.CheckoutPersonResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.auctionboost.CheckoutPersonResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.CheckoutPersonResponse.displayName = 'proto.auctionboost.CheckoutPersonResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auctionboost.Invoice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.auctionboost.Invoice.repeatedFields_, proto.auctionboost.Invoice.oneofGroups_);
};
goog.inherits(proto.auctionboost.Invoice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auctionboost.Invoice.displayName = 'proto.auctionboost.Invoice';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.DeletionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.DeletionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.DeletionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.DeletionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.DeletionRequest}
 */
proto.auctionboost.DeletionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.DeletionRequest;
  return proto.auctionboost.DeletionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.DeletionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.DeletionRequest}
 */
proto.auctionboost.DeletionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.DeletionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.DeletionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.DeletionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.DeletionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.DeletionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.DeletionRequest} returns this
 */
proto.auctionboost.DeletionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.EntityReference.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.EntityReference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.EntityReference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.EntityReference.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.EntityReference}
 */
proto.auctionboost.EntityReference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.EntityReference;
  return proto.auctionboost.EntityReference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.EntityReference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.EntityReference}
 */
proto.auctionboost.EntityReference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.EntityReference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.EntityReference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.EntityReference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.EntityReference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.EntityReference.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.EntityReference} returns this
 */
proto.auctionboost.EntityReference.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
traceid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Response}
 */
proto.auctionboost.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Response;
  return proto.auctionboost.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Response}
 */
proto.auctionboost.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {!proto.auctionboost.MessageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTraceid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Message = 1;
 * @return {string}
 */
proto.auctionboost.Response.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Response} returns this
 */
proto.auctionboost.Response.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MessageType Type = 2;
 * @return {!proto.auctionboost.MessageType}
 */
proto.auctionboost.Response.prototype.getType = function() {
  return /** @type {!proto.auctionboost.MessageType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.auctionboost.MessageType} value
 * @return {!proto.auctionboost.Response} returns this
 */
proto.auctionboost.Response.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string TraceId = 3;
 * @return {string}
 */
proto.auctionboost.Response.prototype.getTraceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Response} returns this
 */
proto.auctionboost.Response.prototype.setTraceid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.DeletionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.DeletionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.DeletionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.DeletionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
msg: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.DeletionResponse}
 */
proto.auctionboost.DeletionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.DeletionResponse;
  return proto.auctionboost.DeletionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.DeletionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.DeletionResponse}
 */
proto.auctionboost.DeletionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.DeletionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.DeletionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.DeletionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.DeletionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string msg = 1;
 * @return {string}
 */
proto.auctionboost.DeletionResponse.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.DeletionResponse} returns this
 */
proto.auctionboost.DeletionResponse.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Email.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Email.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Email} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Email.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
address: jspb.Message.getFieldWithDefault(msg, 2, ""),
label: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Email}
 */
proto.auctionboost.Email.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Email;
  return proto.auctionboost.Email.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Email} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Email}
 */
proto.auctionboost.Email.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Email.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Email.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Email} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Email.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Email.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Email} returns this
 */
proto.auctionboost.Email.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.auctionboost.Email.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Email} returns this
 */
proto.auctionboost.Email.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.auctionboost.Email.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Email} returns this
 */
proto.auctionboost.Email.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
address1: jspb.Message.getFieldWithDefault(msg, 2, ""),
address2: jspb.Message.getFieldWithDefault(msg, 3, ""),
address3: jspb.Message.getFieldWithDefault(msg, 4, ""),
city: jspb.Message.getFieldWithDefault(msg, 5, ""),
state: jspb.Message.getFieldWithDefault(msg, 6, ""),
country: jspb.Message.getFieldWithDefault(msg, 7, ""),
postalCode: jspb.Message.getFieldWithDefault(msg, 8, ""),
label: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Address}
 */
proto.auctionboost.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Address;
  return proto.auctionboost.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Address}
 */
proto.auctionboost.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress3(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalCode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddress3();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPostalCode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address1 = 2;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address2 = 3;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address3 = 4;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getAddress3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setAddress3 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string state = 6;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string country = 7;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string postal_code = 8;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getPostalCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setPostalCode = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string label = 9;
 * @return {string}
 */
proto.auctionboost.Address.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Address} returns this
 */
proto.auctionboost.Address.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.auctionboost.Person.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Person.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Person.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Person} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Person.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 3, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
phone: jspb.Message.getFieldWithDefault(msg, 5, ""),
emailList: jspb.Message.toObjectList(msg.getEmailList(),
    proto.auctionboost.Email.toObject, includeInstance),
addressesList: jspb.Message.toObjectList(msg.getAddressesList(),
    proto.auctionboost.Address.toObject, includeInstance),
notes: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Person}
 */
proto.auctionboost.Person.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Person;
  return proto.auctionboost.Person.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Person} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Person}
 */
proto.auctionboost.Person.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 6:
      var value = new proto.auctionboost.Email;
      reader.readMessage(value,proto.auctionboost.Email.deserializeBinaryFromReader);
      msg.addEmail(value);
      break;
    case 7:
      var value = new proto.auctionboost.Address;
      reader.readMessage(value,proto.auctionboost.Address.deserializeBinaryFromReader);
      msg.addAddresses(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Person.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Person.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Person} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Person.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.auctionboost.Email.serializeBinaryToWriter
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.auctionboost.Address.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Person.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.auctionboost.Person.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_name = 3;
 * @return {string}
 */
proto.auctionboost.Person.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.auctionboost.Person.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string phone = 5;
 * @return {string}
 */
proto.auctionboost.Person.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated Email email = 6;
 * @return {!Array<!proto.auctionboost.Email>}
 */
proto.auctionboost.Person.prototype.getEmailList = function() {
  return /** @type{!Array<!proto.auctionboost.Email>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.auctionboost.Email, 6));
};


/**
 * @param {!Array<!proto.auctionboost.Email>} value
 * @return {!proto.auctionboost.Person} returns this
*/
proto.auctionboost.Person.prototype.setEmailList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.auctionboost.Email=} opt_value
 * @param {number=} opt_index
 * @return {!proto.auctionboost.Email}
 */
proto.auctionboost.Person.prototype.addEmail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.auctionboost.Email, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.clearEmailList = function() {
  return this.setEmailList([]);
};


/**
 * repeated Address addresses = 7;
 * @return {!Array<!proto.auctionboost.Address>}
 */
proto.auctionboost.Person.prototype.getAddressesList = function() {
  return /** @type{!Array<!proto.auctionboost.Address>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.auctionboost.Address, 7));
};


/**
 * @param {!Array<!proto.auctionboost.Address>} value
 * @return {!proto.auctionboost.Person} returns this
*/
proto.auctionboost.Person.prototype.setAddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.auctionboost.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.auctionboost.Address}
 */
proto.auctionboost.Person.prototype.addAddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.auctionboost.Address, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


/**
 * optional string notes = 8;
 * @return {string}
 */
proto.auctionboost.Person.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Person} returns this
 */
proto.auctionboost.Person.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.auctionboost.Organization.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Organization.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Organization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Organization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Organization.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
hidden: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
addressesList: jspb.Message.toObjectList(msg.getAddressesList(),
    proto.auctionboost.Address.toObject, includeInstance),
peopleList: jspb.Message.toObjectList(msg.getPeopleList(),
    proto.auctionboost.PersonLabel.toObject, includeInstance),
invoiceAddressId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Organization}
 */
proto.auctionboost.Organization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Organization;
  return proto.auctionboost.Organization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Organization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Organization}
 */
proto.auctionboost.Organization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 4:
      var value = new proto.auctionboost.Address;
      reader.readMessage(value,proto.auctionboost.Address.deserializeBinaryFromReader);
      msg.addAddresses(value);
      break;
    case 5:
      var value = new proto.auctionboost.PersonLabel;
      reader.readMessage(value,proto.auctionboost.PersonLabel.deserializeBinaryFromReader);
      msg.addPeople(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceAddressId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Organization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Organization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Organization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Organization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.auctionboost.Address.serializeBinaryToWriter
    );
  }
  f = message.getPeopleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.auctionboost.PersonLabel.serializeBinaryToWriter
    );
  }
  f = message.getInvoiceAddressId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Organization.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Organization} returns this
 */
proto.auctionboost.Organization.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.auctionboost.Organization.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Organization} returns this
 */
proto.auctionboost.Organization.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hidden = 3;
 * @return {boolean}
 */
proto.auctionboost.Organization.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Organization} returns this
 */
proto.auctionboost.Organization.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated Address addresses = 4;
 * @return {!Array<!proto.auctionboost.Address>}
 */
proto.auctionboost.Organization.prototype.getAddressesList = function() {
  return /** @type{!Array<!proto.auctionboost.Address>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.auctionboost.Address, 4));
};


/**
 * @param {!Array<!proto.auctionboost.Address>} value
 * @return {!proto.auctionboost.Organization} returns this
*/
proto.auctionboost.Organization.prototype.setAddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.auctionboost.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.auctionboost.Address}
 */
proto.auctionboost.Organization.prototype.addAddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.auctionboost.Address, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.auctionboost.Organization} returns this
 */
proto.auctionboost.Organization.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


/**
 * repeated PersonLabel people = 5;
 * @return {!Array<!proto.auctionboost.PersonLabel>}
 */
proto.auctionboost.Organization.prototype.getPeopleList = function() {
  return /** @type{!Array<!proto.auctionboost.PersonLabel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.auctionboost.PersonLabel, 5));
};


/**
 * @param {!Array<!proto.auctionboost.PersonLabel>} value
 * @return {!proto.auctionboost.Organization} returns this
*/
proto.auctionboost.Organization.prototype.setPeopleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.auctionboost.PersonLabel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.auctionboost.PersonLabel}
 */
proto.auctionboost.Organization.prototype.addPeople = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.auctionboost.PersonLabel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.auctionboost.Organization} returns this
 */
proto.auctionboost.Organization.prototype.clearPeopleList = function() {
  return this.setPeopleList([]);
};


/**
 * optional string invoice_address_id = 6;
 * @return {string}
 */
proto.auctionboost.Organization.prototype.getInvoiceAddressId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Organization} returns this
 */
proto.auctionboost.Organization.prototype.setInvoiceAddressId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.PersonLabel.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.PersonLabel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.PersonLabel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.PersonLabel.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
person: (f = msg.getPerson()) && proto.auctionboost.Person.toObject(includeInstance, f),
notes: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.PersonLabel}
 */
proto.auctionboost.PersonLabel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.PersonLabel;
  return proto.auctionboost.PersonLabel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.PersonLabel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.PersonLabel}
 */
proto.auctionboost.PersonLabel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = new proto.auctionboost.Person;
      reader.readMessage(value,proto.auctionboost.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.PersonLabel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.PersonLabel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.PersonLabel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.PersonLabel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.auctionboost.Person.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.auctionboost.PersonLabel.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.PersonLabel} returns this
 */
proto.auctionboost.PersonLabel.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Person person = 2;
 * @return {?proto.auctionboost.Person}
 */
proto.auctionboost.PersonLabel.prototype.getPerson = function() {
  return /** @type{?proto.auctionboost.Person} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Person, 2));
};


/**
 * @param {?proto.auctionboost.Person|undefined} value
 * @return {!proto.auctionboost.PersonLabel} returns this
*/
proto.auctionboost.PersonLabel.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.PersonLabel} returns this
 */
proto.auctionboost.PersonLabel.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.PersonLabel.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.auctionboost.PersonLabel.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.PersonLabel} returns this
 */
proto.auctionboost.PersonLabel.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.AuctionSeries.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.AuctionSeries.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.AuctionSeries} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.AuctionSeries.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
org: (f = msg.getOrg()) && proto.auctionboost.Organization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.AuctionSeries}
 */
proto.auctionboost.AuctionSeries.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.AuctionSeries;
  return proto.auctionboost.AuctionSeries.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.AuctionSeries} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.AuctionSeries}
 */
proto.auctionboost.AuctionSeries.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.auctionboost.Organization;
      reader.readMessage(value,proto.auctionboost.Organization.deserializeBinaryFromReader);
      msg.setOrg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.AuctionSeries.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.AuctionSeries.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.AuctionSeries} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.AuctionSeries.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrg();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.auctionboost.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.AuctionSeries.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.AuctionSeries} returns this
 */
proto.auctionboost.AuctionSeries.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.auctionboost.AuctionSeries.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.AuctionSeries} returns this
 */
proto.auctionboost.AuctionSeries.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Organization org = 3;
 * @return {?proto.auctionboost.Organization}
 */
proto.auctionboost.AuctionSeries.prototype.getOrg = function() {
  return /** @type{?proto.auctionboost.Organization} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Organization, 3));
};


/**
 * @param {?proto.auctionboost.Organization|undefined} value
 * @return {!proto.auctionboost.AuctionSeries} returns this
*/
proto.auctionboost.AuctionSeries.prototype.setOrg = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.AuctionSeries} returns this
 */
proto.auctionboost.AuctionSeries.prototype.clearOrg = function() {
  return this.setOrg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.AuctionSeries.prototype.hasOrg = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.auctionboost.Auction.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Auction.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Auction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Auction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Auction.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
series: (f = msg.getSeries()) && proto.auctionboost.AuctionSeries.toObject(includeInstance, f),
time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
isonline: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
issilent: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
islocked: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
islive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
livebidprefix: jspb.Message.getFieldWithDefault(msg, 8, ""),
silentbidprefix: jspb.Message.getFieldWithDefault(msg, 9, ""),
liveitemprefix: jspb.Message.getFieldWithDefault(msg, 10, ""),
silentitemprefix: jspb.Message.getFieldWithDefault(msg, 11, ""),
name: jspb.Message.getFieldWithDefault(msg, 12, ""),
websiteUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
requestedServices: jspb.Message.getFieldWithDefault(msg, 14, ""),
hostsList: jspb.Message.toObjectList(msg.getHostsList(),
    proto.auctionboost.Person.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Auction}
 */
proto.auctionboost.Auction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Auction;
  return proto.auctionboost.Auction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Auction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Auction}
 */
proto.auctionboost.Auction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.auctionboost.AuctionSeries;
      reader.readMessage(value,proto.auctionboost.AuctionSeries.deserializeBinaryFromReader);
      msg.setSeries(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsonline(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssilent(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslocked(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslive(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLivebidprefix(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSilentbidprefix(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiveitemprefix(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSilentitemprefix(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsiteUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedServices(value);
      break;
    case 15:
      var value = new proto.auctionboost.Person;
      reader.readMessage(value,proto.auctionboost.Person.deserializeBinaryFromReader);
      msg.addHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Auction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Auction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Auction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Auction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSeries();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.auctionboost.AuctionSeries.serializeBinaryToWriter
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsonline();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIssilent();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIslocked();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIslive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLivebidprefix();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSilentbidprefix();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLiveitemprefix();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSilentitemprefix();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getWebsiteUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getRequestedServices();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getHostsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.auctionboost.Person.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AuctionSeries series = 2;
 * @return {?proto.auctionboost.AuctionSeries}
 */
proto.auctionboost.Auction.prototype.getSeries = function() {
  return /** @type{?proto.auctionboost.AuctionSeries} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.AuctionSeries, 2));
};


/**
 * @param {?proto.auctionboost.AuctionSeries|undefined} value
 * @return {!proto.auctionboost.Auction} returns this
*/
proto.auctionboost.Auction.prototype.setSeries = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.clearSeries = function() {
  return this.setSeries(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Auction.prototype.hasSeries = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.auctionboost.Auction.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.auctionboost.Auction} returns this
*/
proto.auctionboost.Auction.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Auction.prototype.hasTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool IsOnline = 4;
 * @return {boolean}
 */
proto.auctionboost.Auction.prototype.getIsonline = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setIsonline = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool IsSilent = 5;
 * @return {boolean}
 */
proto.auctionboost.Auction.prototype.getIssilent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setIssilent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool IsLocked = 6;
 * @return {boolean}
 */
proto.auctionboost.Auction.prototype.getIslocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setIslocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool isLive = 7;
 * @return {boolean}
 */
proto.auctionboost.Auction.prototype.getIslive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setIslive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string LiveBidPrefix = 8;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getLivebidprefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setLivebidprefix = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string SilentBidPrefix = 9;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getSilentbidprefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setSilentbidprefix = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string LiveItemPrefix = 10;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getLiveitemprefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setLiveitemprefix = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string SilentItemPrefix = 11;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getSilentitemprefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setSilentitemprefix = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string name = 12;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string website_url = 13;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getWebsiteUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setWebsiteUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string requested_services = 14;
 * @return {string}
 */
proto.auctionboost.Auction.prototype.getRequestedServices = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.setRequestedServices = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated Person hosts = 15;
 * @return {!Array<!proto.auctionboost.Person>}
 */
proto.auctionboost.Auction.prototype.getHostsList = function() {
  return /** @type{!Array<!proto.auctionboost.Person>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.auctionboost.Person, 15));
};


/**
 * @param {!Array<!proto.auctionboost.Person>} value
 * @return {!proto.auctionboost.Auction} returns this
*/
proto.auctionboost.Auction.prototype.setHostsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.auctionboost.Person=} opt_value
 * @param {number=} opt_index
 * @return {!proto.auctionboost.Person}
 */
proto.auctionboost.Auction.prototype.addHosts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.auctionboost.Person, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.auctionboost.Auction} returns this
 */
proto.auctionboost.Auction.prototype.clearHostsList = function() {
  return this.setHostsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Money.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Money.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Money} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Money.toObject = function(includeInstance, msg) {
  var f, obj = {
currencyCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
units: jspb.Message.getFieldWithDefault(msg, 2, 0),
nanos: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Money}
 */
proto.auctionboost.Money.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Money;
  return proto.auctionboost.Money.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Money} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Money}
 */
proto.auctionboost.Money.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnits(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Money.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Money.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Money} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Money.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnits();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string currency_code = 1;
 * @return {string}
 */
proto.auctionboost.Money.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Money} returns this
 */
proto.auctionboost.Money.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 units = 2;
 * @return {number}
 */
proto.auctionboost.Money.prototype.getUnits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.auctionboost.Money} returns this
 */
proto.auctionboost.Money.prototype.setUnits = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 nanos = 3;
 * @return {number}
 */
proto.auctionboost.Money.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.auctionboost.Money} returns this
 */
proto.auctionboost.Money.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
auctionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
lotid: jspb.Message.getFieldWithDefault(msg, 3, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
description: jspb.Message.getFieldWithDefault(msg, 5, ""),
fairMarketValue: (f = msg.getFairMarketValue()) && proto.auctionboost.Money.toObject(includeInstance, f),
quantity: jspb.Message.getFieldWithDefault(msg, 7, 0),
type: jspb.Message.getFieldWithDefault(msg, 8, 0),
donatorid: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
pictureUrl: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Item}
 */
proto.auctionboost.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Item;
  return proto.auctionboost.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Item}
 */
proto.auctionboost.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLotid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = new proto.auctionboost.Money;
      reader.readMessage(value,proto.auctionboost.Money.deserializeBinaryFromReader);
      msg.setFairMarketValue(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 8:
      var value = /** @type {!proto.auctionboost.ItemType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDonatorid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictureUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLotid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFairMarketValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.auctionboost.Money.serializeBinaryToWriter
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string auction_id = 2;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string lotId = 3;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getLotid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setLotid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Money fair_market_value = 6;
 * @return {?proto.auctionboost.Money}
 */
proto.auctionboost.Item.prototype.getFairMarketValue = function() {
  return /** @type{?proto.auctionboost.Money} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Money, 6));
};


/**
 * @param {?proto.auctionboost.Money|undefined} value
 * @return {!proto.auctionboost.Item} returns this
*/
proto.auctionboost.Item.prototype.setFairMarketValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.clearFairMarketValue = function() {
  return this.setFairMarketValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Item.prototype.hasFairMarketValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 quantity = 7;
 * @return {number}
 */
proto.auctionboost.Item.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional ItemType type = 8;
 * @return {!proto.auctionboost.ItemType}
 */
proto.auctionboost.Item.prototype.getType = function() {
  return /** @type {!proto.auctionboost.ItemType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.auctionboost.ItemType} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string DonatorId = 9;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getDonatorid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setDonatorid = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.clearDonatorid = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Item.prototype.hasDonatorid = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string picture_url = 10;
 * @return {string}
 */
proto.auctionboost.Item.prototype.getPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Item} returns this
 */
proto.auctionboost.Item.prototype.setPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.SearchTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.SearchTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.SearchTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.SearchTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
limitingid: jspb.Message.getFieldWithDefault(msg, 1, ""),
term: jspb.Message.getFieldWithDefault(msg, 2, ""),
page: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.SearchTerm}
 */
proto.auctionboost.SearchTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.SearchTerm;
  return proto.auctionboost.SearchTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.SearchTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.SearchTerm}
 */
proto.auctionboost.SearchTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLimitingid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerm(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.SearchTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.SearchTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.SearchTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.SearchTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimitingid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTerm();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string LimitingID = 1;
 * @return {string}
 */
proto.auctionboost.SearchTerm.prototype.getLimitingid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.SearchTerm} returns this
 */
proto.auctionboost.SearchTerm.prototype.setLimitingid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Term = 2;
 * @return {string}
 */
proto.auctionboost.SearchTerm.prototype.getTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.SearchTerm} returns this
 */
proto.auctionboost.SearchTerm.prototype.setTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.auctionboost.SearchTerm.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.auctionboost.SearchTerm} returns this
 */
proto.auctionboost.SearchTerm.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Guest.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Guest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Guest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Guest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
person: (f = msg.getPerson()) && proto.auctionboost.Person.toObject(includeInstance, f),
bidNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
ischeckedin: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
notes: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Guest}
 */
proto.auctionboost.Guest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Guest;
  return proto.auctionboost.Guest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Guest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Guest}
 */
proto.auctionboost.Guest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = new proto.auctionboost.Person;
      reader.readMessage(value,proto.auctionboost.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBidNumber(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscheckedin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Guest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Guest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Guest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Guest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.auctionboost.Person.serializeBinaryToWriter
    );
  }
  f = message.getBidNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getIscheckedin();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.auctionboost.Guest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Guest} returns this
 */
proto.auctionboost.Guest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Person person = 2;
 * @return {?proto.auctionboost.Person}
 */
proto.auctionboost.Guest.prototype.getPerson = function() {
  return /** @type{?proto.auctionboost.Person} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Person, 2));
};


/**
 * @param {?proto.auctionboost.Person|undefined} value
 * @return {!proto.auctionboost.Guest} returns this
*/
proto.auctionboost.Guest.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Guest} returns this
 */
proto.auctionboost.Guest.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Guest.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 bid_number = 3;
 * @return {number}
 */
proto.auctionboost.Guest.prototype.getBidNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.auctionboost.Guest} returns this
 */
proto.auctionboost.Guest.prototype.setBidNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool IsCheckedIn = 4;
 * @return {boolean}
 */
proto.auctionboost.Guest.prototype.getIscheckedin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Guest} returns this
 */
proto.auctionboost.Guest.prototype.setIscheckedin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string notes = 5;
 * @return {string}
 */
proto.auctionboost.Guest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Guest} returns this
 */
proto.auctionboost.Guest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.CheckedInResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.CheckedInResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.CheckedInResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.CheckedInResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notes: jspb.Message.getFieldWithDefault(msg, 1, ""),
bidNumber: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.CheckedInResponse}
 */
proto.auctionboost.CheckedInResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.CheckedInResponse;
  return proto.auctionboost.CheckedInResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.CheckedInResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.CheckedInResponse}
 */
proto.auctionboost.CheckedInResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBidNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.CheckedInResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.CheckedInResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.CheckedInResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.CheckedInResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBidNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string notes = 1;
 * @return {string}
 */
proto.auctionboost.CheckedInResponse.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.CheckedInResponse} returns this
 */
proto.auctionboost.CheckedInResponse.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bid_number = 2;
 * @return {string}
 */
proto.auctionboost.CheckedInResponse.prototype.getBidNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.CheckedInResponse} returns this
 */
proto.auctionboost.CheckedInResponse.prototype.setBidNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.ClerkedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.ClerkedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.ClerkedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.ClerkedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
lotId: jspb.Message.getFieldWithDefault(msg, 2, ""),
bidNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
price: (f = msg.getPrice()) && proto.auctionboost.Money.toObject(includeInstance, f),
notes: jspb.Message.getFieldWithDefault(msg, 5, ""),
item: (f = msg.getItem()) && proto.auctionboost.Item.toObject(includeInstance, f),
id: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.ClerkedItem}
 */
proto.auctionboost.ClerkedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.ClerkedItem;
  return proto.auctionboost.ClerkedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.ClerkedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.ClerkedItem}
 */
proto.auctionboost.ClerkedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLotId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBidNumber(value);
      break;
    case 4:
      var value = new proto.auctionboost.Money;
      reader.readMessage(value,proto.auctionboost.Money.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 6:
      var value = new proto.auctionboost.Item;
      reader.readMessage(value,proto.auctionboost.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.ClerkedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.ClerkedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.ClerkedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.ClerkedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLotId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBidNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.auctionboost.Money.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.auctionboost.Item.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.auctionboost.ClerkedItem.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string lot_id = 2;
 * @return {string}
 */
proto.auctionboost.ClerkedItem.prototype.getLotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.setLotId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string bid_number = 3;
 * @return {string}
 */
proto.auctionboost.ClerkedItem.prototype.getBidNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.setBidNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Money price = 4;
 * @return {?proto.auctionboost.Money}
 */
proto.auctionboost.ClerkedItem.prototype.getPrice = function() {
  return /** @type{?proto.auctionboost.Money} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Money, 4));
};


/**
 * @param {?proto.auctionboost.Money|undefined} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
*/
proto.auctionboost.ClerkedItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.ClerkedItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string notes = 5;
 * @return {string}
 */
proto.auctionboost.ClerkedItem.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Item item = 6;
 * @return {?proto.auctionboost.Item}
 */
proto.auctionboost.ClerkedItem.prototype.getItem = function() {
  return /** @type{?proto.auctionboost.Item} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Item, 6));
};


/**
 * @param {?proto.auctionboost.Item|undefined} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
*/
proto.auctionboost.ClerkedItem.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.ClerkedItem.prototype.hasItem = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string id = 7;
 * @return {string}
 */
proto.auctionboost.ClerkedItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkedItem} returns this
 */
proto.auctionboost.ClerkedItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.ClerkItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.ClerkItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.ClerkItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.ClerkItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
msg: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.ClerkItemResponse}
 */
proto.auctionboost.ClerkItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.ClerkItemResponse;
  return proto.auctionboost.ClerkItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.ClerkItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.ClerkItemResponse}
 */
proto.auctionboost.ClerkItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.ClerkItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.ClerkItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.ClerkItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.ClerkItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.ClerkItemResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkItemResponse} returns this
 */
proto.auctionboost.ClerkItemResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool status = 2;
 * @return {boolean}
 */
proto.auctionboost.ClerkItemResponse.prototype.getStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.ClerkItemResponse} returns this
 */
proto.auctionboost.ClerkItemResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string msg = 3;
 * @return {string}
 */
proto.auctionboost.ClerkItemResponse.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.ClerkItemResponse} returns this
 */
proto.auctionboost.ClerkItemResponse.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.CheckoutPersonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.CheckoutPersonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.CheckoutPersonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.CheckoutPersonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
personId: jspb.Message.getFieldWithDefault(msg, 1, ""),
method: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.CheckoutPersonRequest}
 */
proto.auctionboost.CheckoutPersonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.CheckoutPersonRequest;
  return proto.auctionboost.CheckoutPersonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.CheckoutPersonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.CheckoutPersonRequest}
 */
proto.auctionboost.CheckoutPersonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.CheckoutPersonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.CheckoutPersonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.CheckoutPersonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.CheckoutPersonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string person_id = 1;
 * @return {string}
 */
proto.auctionboost.CheckoutPersonRequest.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.CheckoutPersonRequest} returns this
 */
proto.auctionboost.CheckoutPersonRequest.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string method = 2;
 * @return {string}
 */
proto.auctionboost.CheckoutPersonRequest.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.CheckoutPersonRequest} returns this
 */
proto.auctionboost.CheckoutPersonRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.CheckoutPersonResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.CheckoutPersonResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.CheckoutPersonResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.CheckoutPersonResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
msg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.CheckoutPersonResponse}
 */
proto.auctionboost.CheckoutPersonResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.CheckoutPersonResponse;
  return proto.auctionboost.CheckoutPersonResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.CheckoutPersonResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.CheckoutPersonResponse}
 */
proto.auctionboost.CheckoutPersonResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.CheckoutPersonResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.CheckoutPersonResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.CheckoutPersonResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.CheckoutPersonResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.CheckoutPersonResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.CheckoutPersonResponse} returns this
 */
proto.auctionboost.CheckoutPersonResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string msg = 2;
 * @return {string}
 */
proto.auctionboost.CheckoutPersonResponse.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.CheckoutPersonResponse} returns this
 */
proto.auctionboost.CheckoutPersonResponse.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.auctionboost.Invoice.repeatedFields_ = [13];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.auctionboost.Invoice.oneofGroups_ = [[7,8],[10,11]];

/**
 * @enum {number}
 */
proto.auctionboost.Invoice.BuyersAddressChoiceCase = {
  BUYERS_ADDRESS_CHOICE_NOT_SET: 0,
  BUYERS_ADDRESS: 7,
  BUYERS_ADDRESS_ID: 8
};

/**
 * @return {proto.auctionboost.Invoice.BuyersAddressChoiceCase}
 */
proto.auctionboost.Invoice.prototype.getBuyersAddressChoiceCase = function() {
  return /** @type {proto.auctionboost.Invoice.BuyersAddressChoiceCase} */(jspb.Message.computeOneofCase(this, proto.auctionboost.Invoice.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.auctionboost.Invoice.BuyersEmailChoiceCase = {
  BUYERS_EMAIL_CHOICE_NOT_SET: 0,
  BUYERS_EMAIL: 10,
  BUYERS_EMAIL_ID: 11
};

/**
 * @return {proto.auctionboost.Invoice.BuyersEmailChoiceCase}
 */
proto.auctionboost.Invoice.prototype.getBuyersEmailChoiceCase = function() {
  return /** @type {proto.auctionboost.Invoice.BuyersEmailChoiceCase} */(jspb.Message.computeOneofCase(this, proto.auctionboost.Invoice.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auctionboost.Invoice.prototype.toObject = function(opt_includeInstance) {
  return proto.auctionboost.Invoice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auctionboost.Invoice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Invoice.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
number: jspb.Message.getFieldWithDefault(msg, 2, 0),
auctionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
personId: jspb.Message.getFieldWithDefault(msg, 4, ""),
paid: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
pb_void: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
buyersAddress: (f = msg.getBuyersAddress()) && proto.auctionboost.Address.toObject(includeInstance, f),
buyersAddressId: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
sellersAddressId: jspb.Message.getFieldWithDefault(msg, 9, ""),
buyersEmail: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
buyersEmailId: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
buyersPhone: jspb.Message.getFieldWithDefault(msg, 12, ""),
itemIdsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
donation: (f = msg.getDonation()) && proto.auctionboost.Money.toObject(includeInstance, f),
total: (f = msg.getTotal()) && proto.auctionboost.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auctionboost.Invoice}
 */
proto.auctionboost.Invoice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auctionboost.Invoice;
  return proto.auctionboost.Invoice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auctionboost.Invoice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auctionboost.Invoice}
 */
proto.auctionboost.Invoice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaid(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVoid(value);
      break;
    case 7:
      var value = new proto.auctionboost.Address;
      reader.readMessage(value,proto.auctionboost.Address.deserializeBinaryFromReader);
      msg.setBuyersAddress(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyersAddressId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSellersAddressId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyersEmail(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyersEmailId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyersPhone(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addItemIds(value);
      break;
    case 14:
      var value = new proto.auctionboost.Money;
      reader.readMessage(value,proto.auctionboost.Money.deserializeBinaryFromReader);
      msg.setDonation(value);
      break;
    case 15:
      var value = new proto.auctionboost.Money;
      reader.readMessage(value,proto.auctionboost.Money.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auctionboost.Invoice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auctionboost.Invoice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auctionboost.Invoice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auctionboost.Invoice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPaid();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getVoid();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getBuyersAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.auctionboost.Address.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSellersAddressId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getBuyersPhone();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getItemIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getDonation();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.auctionboost.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.auctionboost.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 number = 2;
 * @return {number}
 */
proto.auctionboost.Invoice.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string auction_id = 3;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string person_id = 4;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool paid = 5;
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.getPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool void = 6;
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.getVoid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setVoid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional Address buyers_address = 7;
 * @return {?proto.auctionboost.Address}
 */
proto.auctionboost.Invoice.prototype.getBuyersAddress = function() {
  return /** @type{?proto.auctionboost.Address} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Address, 7));
};


/**
 * @param {?proto.auctionboost.Address|undefined} value
 * @return {!proto.auctionboost.Invoice} returns this
*/
proto.auctionboost.Invoice.prototype.setBuyersAddress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.auctionboost.Invoice.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearBuyersAddress = function() {
  return this.setBuyersAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.hasBuyersAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string buyers_address_id = 8;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getBuyersAddressId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setBuyersAddressId = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.auctionboost.Invoice.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearBuyersAddressId = function() {
  return jspb.Message.setOneofField(this, 8, proto.auctionboost.Invoice.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.hasBuyersAddressId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string sellers_address_id = 9;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getSellersAddressId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setSellersAddressId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string buyers_email = 10;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getBuyersEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setBuyersEmail = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.auctionboost.Invoice.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearBuyersEmail = function() {
  return jspb.Message.setOneofField(this, 10, proto.auctionboost.Invoice.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.hasBuyersEmail = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string buyers_email_id = 11;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getBuyersEmailId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setBuyersEmailId = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.auctionboost.Invoice.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearBuyersEmailId = function() {
  return jspb.Message.setOneofField(this, 11, proto.auctionboost.Invoice.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.hasBuyersEmailId = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string buyers_phone = 12;
 * @return {string}
 */
proto.auctionboost.Invoice.prototype.getBuyersPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setBuyersPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string item_ids = 13;
 * @return {!Array<string>}
 */
proto.auctionboost.Invoice.prototype.getItemIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.setItemIdsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.addItemIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearItemIdsList = function() {
  return this.setItemIdsList([]);
};


/**
 * optional Money donation = 14;
 * @return {?proto.auctionboost.Money}
 */
proto.auctionboost.Invoice.prototype.getDonation = function() {
  return /** @type{?proto.auctionboost.Money} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Money, 14));
};


/**
 * @param {?proto.auctionboost.Money|undefined} value
 * @return {!proto.auctionboost.Invoice} returns this
*/
proto.auctionboost.Invoice.prototype.setDonation = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearDonation = function() {
  return this.setDonation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.hasDonation = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Money total = 15;
 * @return {?proto.auctionboost.Money}
 */
proto.auctionboost.Invoice.prototype.getTotal = function() {
  return /** @type{?proto.auctionboost.Money} */ (
    jspb.Message.getWrapperField(this, proto.auctionboost.Money, 15));
};


/**
 * @param {?proto.auctionboost.Money|undefined} value
 * @return {!proto.auctionboost.Invoice} returns this
*/
proto.auctionboost.Invoice.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.auctionboost.Invoice} returns this
 */
proto.auctionboost.Invoice.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auctionboost.Invoice.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * @enum {number}
 */
proto.auctionboost.MessageType = {
  INFO: 0,
  WARN: 1,
  ERROR: 2,
  DEBUG: 3,
  TRACE: 4,
  NOTREADY: 5
};

/**
 * @enum {number}
 */
proto.auctionboost.ItemType = {
  SILENT: 0,
  LIVE: 1
};

goog.object.extend(exports, proto.auctionboost);
